const isMoment = value =>
    value.hasOwnProperty("_d") &&
    value.hasOwnProperty("_a") &&
    value.hasOwnProperty("_isUTC");

export default isMoment;



// WEBPACK FOOTER //
// ./app/data/util/isMoment.js